
function fetchLocationData() {
  fetch('https://ipinfo.io/?token=daa304eb51cfba')
    .then((res) => res.json())
    .then((res) => {
        let locationData = JSON.stringify(res);
        setGeoCookie("geolocation", locationData, 1);
        updateStateRestriction(res.region);
    });
}

function setGeoCookie (cname,cvalue,exdays){
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getGeoCookie (cname){
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function getSavedLocation (){
  let location = getGeoCookie("geolocation");
  if (location && location != "") {
    let locationData = JSON.parse(location);
    updateStateRestriction(locationData.region);
  }
}

function updateStateRestriction (region) {
  let stateRestriction = document.querySelector('[data-pdp-state-restriction]');
    console.log(stateRestriction);
  if(typeof window.stateRestriction != 'undefined' && window.stateRestriction && stateRestriction) {
    if(window.stateRestriction.states.includes(region)) {
      stateRestriction.classList.remove('state-restriction--invalid');
      stateRestriction.classList.add('state-restriction--valid');
      document.querySelector('[data-buttons-wrapper]').remove();
    }
  }
}

function initStateRestriction() {
  if (document.querySelector('[data-pdp-state-restriction]')){
    if (!getGeoCookie("geolocation")){
      fetchLocationData();
    } else {
      getSavedLocation();
    }
  }
}

initStateRestriction();